import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconRemoveBackground2: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-filled-radius-0-stroke-1.5-IconRemoveBackground2"><Path fillRule="evenodd" clipRule="evenodd" d="M12.75 3H21V21H12.75V23H11.25V21H3V3H11.25V1H12.75V3ZM8 8H4.5V12H8V16H4.5V19.5H8V16H11.25V12H8V8H11.25V4.5H8V8Z" fill="currentColor"/></CentralIconBase>;
});

export default IconRemoveBackground2;
